import React, { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'

import { ILabelValueInfoProps } from './LabelValueInfo.types'
import { Info, LabelCard, Title, Value } from './styles'

const LabelValueInfo: FunctionComponent<ILabelValueInfoProps> = ({
  title,
  value,
  info,
}) => {
  return (
    <LabelCard>
      <Grid container>
        <Title>{title}</Title>

        <Grid container>
          <Grid item md={12}>
            <Value>{value}</Value>
          </Grid>
          <Grid item md={12}>
            <Info>{info}</Info>
          </Grid>
        </Grid>
      </Grid>
    </LabelCard>
  )
}

export default LabelValueInfo
